export interface DiscountTotalInput {
  voucher?: { amount?: number | string } | null;
  discount?: { amount?: number | string } | null;
  mordy?: { amount?: number | string } | null;
  total?: number | string | null;
}

export const discountTotal = (order: DiscountTotalInput = {}): number => {
  const voucherTotal = Number(order?.voucher?.amount) || 0;
  const discountTotalAmount = Number(order?.discount?.amount) || 0;
  const mordyTotal = Number(order?.mordy?.amount) || 0;

  return voucherTotal + discountTotalAmount + mordyTotal;
};

export const getDisplayTotal = (order: DiscountTotalInput = {}, fallbackTotal?: number): number => {
  const baseTotal = fallbackTotal !== undefined ? fallbackTotal : Number(order?.total) || 0;
  const deductions = discountTotal(order);
  const result = baseTotal - deductions;
  return result > 0 ? result : 0;
};
